import * as React from 'react';
import { cn } from '../../utils/cn';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'min-h-[80px] w-full rounded border border-neutral-200 bg-white px-3 py-2 text-sm text-neutral-900 transition-colors outline-hidden',
        'placeholder:text-neutral-400',
        'resize-y',
        'focus:outline-none focus:ring-2 focus:ring-primary-500/30 focus:border-primary-500',
        'disabled:opacity-50 disabled:bg-neutral-50',
        'aria-invalid:border-danger aria-invalid:ring-2 aria-invalid:ring-danger/30',
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
